import React, { useEffect, useState } from 'react';
import { FaAward } from 'react-icons/fa';
import { VscFolderLibrary } from 'react-icons/vsc';
import Myimg from '../../../assets/we.png';
import './about.css';

const About = () => {
  const [experienceYear, setexperienceYear] = useState(new Date().getFullYear());

  useEffect(() => { 
    setexperienceYear(new Date().getFullYear() - 2022 );
  }, []);
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about-container">
        <div className="about-me">
          <div className="about-me-img">
            <img src={Myimg} alt="Profile" />
          </div>

        </div>
        <div className="about-content">
          <div className="about-cards">
            <article className="about-card">
              <FaAward className="about-icon" />
              <h5>Experience</h5>
              <small>{experienceYear} years</small>
            </article>
            <article className="about-card">
              <VscFolderLibrary className="about-icon" />
              <h5>Projects</h5>
              <small>9+</small>
            </article>
          </div>
          <p>
            <p>Hello, my name is <strong>Aoumara Yacine</strong>. I am a full-stack developer. My expertise spans across a variety of technologies, including <strong>Django, WPF, React, Flutter, GitHub, and DevOps</strong>.</p>
            <p>Throughout my career, I have successfully developed and deployed numerous web and mobile applications, leveraging my skills in both front-end and back-end development. My experience with these technologies has enabled me to create robust, scalable, and user-friendly solutions tailored to meet the specific needs of my clients.</p>
          </p>
          <a href="#contact" className="btn btn-primary">
            Get in touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
